import ServiceDetailPage from "./ServiceDetailPage";
import serviceContent from "./serviceContent";

const AIBusiness = () => <ServiceDetailPage service={serviceContent.aiBusiness} />;

export default AIBusiness;
